<template>
    <div style="display: flex; flex-direction: column;">
        <ModalHeader title="근무 예약" :is-show-back-btn="false" :is_left_area_custom="false" >
            <!--<template :slot="'left_area'">-->
                <!--<div style="width:100%; display:grid;place-items: center;">-->
                    <!--<div style="width:38px; padding:0px 10px;" @click="showSetting">-->
                        <!--<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"/></svg>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</template>-->
        </ModalHeader>
        <div style=" flex:1; overflow:auto;">
            <Calendar :selectDateCallback="selectDateHandler" :startDate="selectedDate" :monthChangeHandler="monthChangeHandler" :detectMonthChangeCall="signalMonthChangeCall" :is-toggle-hidden="true" :is-first-show-month="true"></Calendar>
            <div style="padding:0px 15px;">
                <div class="guide"><div class="guide_color" style="background-color: #A9D49C;"></div>예약가능 : 예약이 가능한 날</div>
                <div class="guide"><div class="guide_color" style="background-color: #94CBEF;"></div>예약신청 : 예약 가능한 날짜에 예약을 신청한 날</div>
                <div class="guide"><div class="guide_color" style="background-color: #F9C156;"></div>예약확정 : 예약이 확정된 날</div>
                <div class="guide"><div class="guide_color" style="background-color: #FFF16A;"></div>근무중 : 출근하여 아직 퇴근을 안 한 경우</div>
                <div class="guide"><div class="guide_color" style="background-color: #E2E1E0;"></div>근무 완료 : 예약 후 근무까지 마친 날</div>
                <div class="guide"><div class="guide_color" style="background-color: #ED724A;"></div>근무 불참 : 예약이 확정되었으나 근무에 불참한 날</div>
            </div>
            <div style="height:15px;"></div>
            <!--<div style="height: 10px; background-color: #ebebeb;"></div>-->
            <!--<div style="padding-top:30px; padding-left:25px; font-size:15px; color:#666">{{selectedDateStr}}</div>-->
            <!--<div style="">-->
                <!--<div v-for="each, i in works" :key="i" class="row" style="padding:25px; display:flex;">-->
                    <!--<div style="display:grid; place-items: center;">-->
                        <!--<div>-->
                            <!--<div style="font-size:20px;">{{each.begin_time}} ~ {{each.end_time}}</div>-->
                            <!--<div style="margin-top:5px; font-size:14px; color:#666">모집인원 : {{each.worker_count | comma}}, 임금 : {{each.pay | comma}}원</div>-->
                        <!--</div>-->
                    <!--</div>-->
                    <!--<div style="flex:1;"></div>-->
                    <!--<div>-->
                        <!--<div v-if="each.is_time_over" class="rounded_square cancel">마감</div>-->
                        <!--<div v-else-if="!each.work_calendar_list" class="rounded_square available" @click="checkSurvey(each)">신청<br>가능</div>-->
                        <!--<div v-else-if="each.work_calendar_list && each.work_calendar_list.state === '대기'" class="rounded_square wait">대기</div>-->
                        <!--<div v-else-if="each.work_calendar_list && each.work_calendar_list.state === '확정'" class="rounded_square complete">확정</div>-->
                        <!--<div v-else-if="each.work_calendar_list && each.work_calendar_list.state === '취소'" class="rounded_square cancel">취소</div>-->
                    <!--</div>-->
                    <!--<div style="margin-left:5px;">-->
                        <!--<div v-if="!each.is_time_over && each.work_calendar_list && each.work_calendar_list.state === '대기'" class="rounded_square cancel" style="background-color: #ee5f5f;" @click="cancelApply(each)">취소</div>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</div>-->
        </div>
        <PageBottom />
    </div>
</template>

<script>
    import moment from 'moment';
    import Calendar from "../common/Calendar";
    import ModalHeader from "../common/ModalHeader";
    import ResponseCode from "../../ResponseCode";
    import PageBottom from "../common/PageBottom";

    export default {
        name: "Reservation",
        components: {PageBottom, ModalHeader, Calendar},
        props:['data'],
        data(){
            return {
                works : [],
                selectedDateStr : '',
                selectedDate: '',
                signalMonthChangeCall : false,
                msg : '',
                beginTime : '',
                endTime : '',
            }
        },
        methods : {
            // showSetting(){
            //     this.$GlobalStore.addModal('Setting');
            // },
            selectDateHandler(reservation){
                if(!reservation) return;

                let btn_state = reservation.btn_state;
                //예약 처리
                if(btn_state === 'available'){
                    this.showApplicationForm(reservation)
                //예약 취소 처리
                } else if(btn_state === 'applied'){
                    this.cancelApply(reservation);
                }

                // this.selectedDateStr = this.$Util.getMMDDDayStr(dateStr);
                // this.selectedDate = dateStr;
                // this.getWorks();
            },
            async monthChangeHandler(callback, year, month){
                let targetDate = this.selectedDate;
                if(this.selectedDate.substr(8, 2) == '00'){
                    targetDate = this.selectedDate.substr(0, 7) + '01';
                }

                const startDate = moment(targetDate, "YYYY-MM-DD").format(year + '-' + month + '-01');
                const endDate = moment(targetDate, "YYYY-MM-DD").format(year + '-' + month + '-31');

                const parameters = {};
                parameters.begin_date = startDate;
                parameters.end_date = endDate;

                const res = await this.$Axios.get('/api/work/list/cnt', {params : parameters});

                callback(res.data.work_calendar) ;
            },
            async getWorks(){
                const parameters = {};
                parameters.begin_date = this.selectedDate;
                parameters.end_date = this.selectedDate;

                const res = await this.$Axios.get('/api/work/list', {params : parameters});
                this.works = res.data.works;
            },
            async showApplicationForm(reservation){
                const confirmTitle = '예약 하시겠습니까?';
                this.$GlobalStore.showConfirm(confirmTitle, async() => {
                    const parameters = {};
                    parameters.idx = reservation.idx;

                    const res = await this.$Axios.post('/api/work/apply', parameters);
                    if(res.data.code === ResponseCode.SUCCESS){
                        this.signalMonthChangeCall = !this.signalMonthChangeCall;
                    }else if(res.data.code === ResponseCode.FAIL){
                        this.$GlobalStore.showAlert(res.data.msg);
                    }
                }, '확인', '닫기')
            },
            showSurvey(reservation){
                this.$GlobalStore.addModal('Survey', {completeAction : () => {
                        this.showApplicationForm(reservation);
                    }
                });
            },
            async checkSurvey(reservation){
                const res = await this.$Axios.get('/api/member/survey/check');
                if(res.data.code === ResponseCode.SUCCESS) {
                    this.showApplicationForm(reservation);
                }else if(res.data.code === 1){
                    this.showSurvey(reservation);
                } else if(res.data.code === ResponseCode.FAIL){
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            },
            async cancelApply(reservation){

                const confirmTitle = '예약을 취소 하시겠습니까?';
                this.$GlobalStore.showConfirm(confirmTitle, async() => {
                    const parameters = {};
                    parameters.idx = reservation.idx;

                    const res = await this.$Axios.post('/api/work/cancel', parameters);
                    if(res.data.code === ResponseCode.SUCCESS){
                        // this.getWorks();
                        this.signalMonthChangeCall = !this.signalMonthChangeCall;
                    }else if(res.data.code === ResponseCode.FAIL){
                        this.$GlobalStore.showAlert(res.data.msg);
                    }
                }, '확인', '닫기')
            }
        },
        created(){
            this.cancelApply = this.$Once(this.cancelApply);

            const today = moment().format('YYYY-MM-DD');
            this.selectedDateStr = this.$Util.getMMDDDayStr(today);
            this.selectedDate = today;

            // this.getWorks();
        }

    }
</script>

<style scoped>
    .row + .row{border-top:1px solid #e5e5e5;}
    .rounded_square{padding: 10px 15px; border-radius:5px; height:56px; width:56px; line-height: 17px; display:grid;place-items: center; }
    .available{background-color: #4c84ff; color:white;}
    .cancel{background: #7587ad;color: #fff;}
    .complete{background: #1ab394;color: white;}
    .wait{  background-color: #c1e3fc;
        color: #4c84ff;}

    .guide{font-size:14px; display:flex; align-items: center; padding:4px; font-weight:500;}
    .guide_color{border-radius: 3px; width:12px; height:12px; margin-right:5px;}


</style>